import React from 'react';
import { MainLoginState } from './constants';
import { PasswordlessLoginContext } from '../PasswordlessLoginContextProvider';
import { MainLoginContext } from './MainLoginContextProvider';
import EmailInputWithContinueButton from '../../EmailInputWithContinueButton';

export default function EnterYourEmail({ notice }: { notice?: React.ReactNode }) {
  const passwordlessLoginContextStore = React.useContext(PasswordlessLoginContext);
  const email = passwordlessLoginContextStore.context.email;
  const setPasswordlessLoginContext = passwordlessLoginContextStore.setContext;
  const setMainLoginContext = React.useContext(MainLoginContext).setContext;

  const handleContinue = async () => {
    setMainLoginContext({ state: MainLoginState.LOGIN_METHOD_SELECTION });
  };

  return (
    <>
      {notice}
      <EmailInputWithContinueButton
        initialEmail={email}
        onEmailChange={(email) => setPasswordlessLoginContext({ email })}
        onSubmit={handleContinue}
      />
    </>
  );
}
